module.exports = __webpack_public_path__ + "img/brand-03.ff3554f6.png";